import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { APIClient } from "../../../helpers/ApiHelper";

// getProfileTypes thunk with osType parameter
export const getProfileTypes = createAsyncThunk(
    "getFilteredDevice",
    async () => {
        try {
            const apiClient = new APIClient();
            const response = await apiClient.get("/api/v1/device/property/personas");
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const profileTypesSlice = createSlice({
    name: "ProfileTypesSlice",
    initialState: {
        loading: false,
        profileTypes: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProfileTypes.pending, (state) => {
                state.loading = true;
            })
            .addCase(getProfileTypes.fulfilled, (state, action) => {
                state.loading = false;
                state.profileTypes = action.payload.items;
            })
            .addCase(getProfileTypes.rejected, (state) => {
                state.loading = false;
                state.profileTypes = [];
            });
    },
});

export default profileTypesSlice.reducer;
